module.exports = __webpack_public_path__ + "img/slide_4.f7360481.jpg";